// extracted by mini-css-extract-plugin
module.exports = {"container":"authorContainer_container__wT3DT","card":"authorContainer_card__5ACCl","cover":"authorContainer_cover__kIdaf"};